var httpLib = require('./http-library');
var _ = require('lodash');
var publicConfig = require('../public-config');
var btoa = require('btoa');

exports.getWebEnv = function (locale, callback, query) {
  var env_base64 = Buffer.from(publicConfig.env_handshake).toString('base64');
  var request_params = {
    host: publicConfig.external_address,
    path: `/v1/env/web/${locale || 'en-US'}${query || ''}`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + env_base64
    }
  };

  httpLib.request(request_params, function (response) {
    return callback(response);
  });
};


exports.serverGetWeb = function serverGet (callback) {
  var requestParams = {
    host: publicConfig.external_address,
    path: '/bookings/web/env',
    method: 'GET'
  };

  httpLib.request(requestParams, callback);
};

exports.getMetros = (function () {
  var cache = {};
  var maxAge = 300000;

  function find (timeNow, callback) {
    var lastSave = cache.timestamp || 0;
    var timeSpan = timeNow - lastSave;
    find.saveEnv = function (env) {
      cache.metros = env.metros;
      cache.timestamp = timeNow;
      return callback(cache.metros);
    };
    // if metros has been saved,
    if (lastSave && (timeSpan < maxAge)) {
      return callback(cache.metros);
    }
    // Not in the cache, so compute the value and put it in the cache
    return exports.getWebEnv(find.saveEnv);
  }
  return find;
}());

exports.findMetroByKey = function (keyValObject, callback) {
  exports.getMetros(Date.now(), function (response) {
    var metro = _.find(response, function (m) {
      return (m.name).toLowerCase() === (keyValObject.name).toLowerCase();
    });
    var responseObject = {
      match: metro,
      available_metros: _.filter(response, { active: true })
    };
    callback(responseObject);
  });
};

exports.getActivities = function (locale, callback) {
  var env_base64 = Buffer.from(publicConfig.env_handshake).toString("base64");
  var request_params = {
    host: publicConfig.external_address,
    path: `/v1/env/keywords/${locale || 'en-US'}`,
    method: 'GET',
    headers: {
      "Authorization": "Bearer " + env_base64
    }
  }

  httpLib.request(request_params, (response) => {
    return callback(response);
  });
};

exports.getTagActivities = function (locale, callback) {
  var env_base64 = btoa(publicConfig.env_handshake);
  var request_params = {
    host: publicConfig.external_address,
    path: `/v1/env/activities/${locale || 'en-US'}`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + env_base64
    }
  };

  httpLib.request(request_params, function (response) {
    return callback(response);
  });
};

exports.getAddOnsCategories = (locale, callback) => {
  const request_params = {
    host: publicConfig.external_address,
    path: `/v1/env/addons/${locale || 'en-US'}`,
    method: 'GET'
  };

  httpLib.request(request_params, (response) => {
    return callback(response);
  });
};

exports.getSpaces = (locale, callback) => {
  const request_params = {
    host: publicConfig.external_address,
    path: `/v1/env/spaces/${locale}`,
    method: 'GET'
  };

  httpLib.request(request_params, (response) => {
    return callback(response);
  });
};

exports.getAllCountries = (locale, callback) => {
  const request_params = {
    host: publicConfig.external_address,
    path: `/v1/env/countries_list/${locale || 'en-US'}`,
    method: 'GET'
  };

  httpLib.request(request_params, (response) => {
    return callback(response);
  });
}
